import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../app-js/shared/shared.module';
import { NotFoundPageComponent } from '../../shared/pages/not-found-page.component';
import { UnauthorizedPageComponent } from '../../shared/pages/unauthorized-page.component';
import { CallbackComponent } from './component/authCallback/callback.component';
import { BrowserDialogComponent } from './component/browser-dialog/browser-dialog.component';
import { LoginComponent } from './component/login/login.component';
import { SecurityRoutingModule } from './security-routing.module';

@NgModule({
  imports: [CommonModule, SecurityRoutingModule, SharedModule],
  providers: [],
  declarations: [
    LoginComponent,
    BrowserDialogComponent,
    CallbackComponent,
    UnauthorizedPageComponent,
    NotFoundPageComponent
  ],
  exports: [
    LoginComponent,
    CallbackComponent,
    UnauthorizedPageComponent,
    NotFoundPageComponent
  ],
  entryComponents: [BrowserDialogComponent]
})
export class SecurityModule {}
